import React, { createContext } from 'react';

const AppContext = createContext({});
const PanelServiceContext = createContext({});
export { AppContext, PanelServiceContext };
